/**
 * Shared predicates for HTTP error shapes.
 *
 * Kept out of containers/App/actions.js deliberately: this is a pure predicate,
 * not an action creator, and it already has consumers in three modules outside
 * that container (App/saga, CreateTripPage/saga, trip-creation/createTripSaga).
 * Importing a predicate from an actions module invites the next caller to
 * re-implement it instead.
 */

/**
 * True when the error is the server refusing on permissions grounds.
 *
 * 401 and 403 are both treated as authorization answers rather than transient
 * failures: neither is fixed by retrying, and both should surface the same
 * message to the user. Callers use this to decide whether to retry, whether to
 * toast, and whether to treat a polled result as settled.
 *
 * @param {*} error - an axios-style error, or anything else
 * @returns {boolean}
 */
export function isAuthorizationError(error) {
  const status = error?.response?.status;
  return status === 401 || status === 403;
}

export default isAuthorizationError;
